import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const History = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M1.36668 8.66667C1.7039 12.0234 4.55826 14.6667 8.00002 14.6667C11.6667 14.6667 14.6667 11.6667 14.6667 8C14.6667 4.33333 11.6667 1.33333 8.00002 1.33333C5.37001 1.33333 3.08299 2.87679 2.00002 5.10263L2.00002 3.33333H0.666687V7.33333L4.66669 7.33333V6H3.05803C3.85332 4.05009 5.77296 2.66667 8.00002 2.66667C10.9334 2.66667 13.3334 5.06667 13.3334 8C13.3334 10.9333 10.9334 13.3333 8.00002 13.3333C5.29235 13.3333 3.03911 11.2884 2.70845 8.66667H1.36668ZM8.26675 9.93333L11.0668 8.6L10.4668 7.4L8.66675 8.26667V4.66667H7.33342V9.33333L8.26675 9.93333Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default History;
